import {AlbumTrack} from './AlbumTrack';

export class AlbumDisc {
  number: number;
  title: string;
  tracks: AlbumTrack[];
}
